module.exports = __webpack_public_path__ + "img/member-empty@3x.fa0e8b4b.png";